import React from "react";

import styles from "./Bot.module.scss";
import clsx from "clsx";

interface ChatBodyProps {
  isOpen: boolean;
}

const ChatBodyWrap: React.FC<React.PropsWithChildren<ChatBodyProps>> = ({
  children,
  isOpen,
}) => {
  const classNameContainerBody = clsx(styles.chatBodyContainer, {
    [styles.chatBodyContainerOpen]: isOpen,
  });

  return <div className={classNameContainerBody}>{children}</div>;
};

export default ChatBodyWrap;
